import { render, staticRenderFns } from "./CruiseDetailPolicy.vue?vue&type=template&id=fd607e88&scoped=true"
import script from "./CruiseDetailPolicy.vue?vue&type=script&lang=js"
export * from "./CruiseDetailPolicy.vue?vue&type=script&lang=js"
import style0 from "./CruiseDetailPolicy.vue?vue&type=style&index=0&id=fd607e88&prod&lang=less&scoped=true"
import style1 from "./CruiseDetailPolicy.vue?vue&type=style&index=1&id=fd607e88&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd607e88",
  null
  
)

export default component.exports